import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { confirmation, IConfirmationDialogResult } from 'app/shared/elements/ess-confirm';
import { guid } from 'app/shared/lib/guid';

@autoinject()
export class DemoEssConfirmPage extends ComponentBase {
    protected id: guid = guid();

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
    }

    ////****************** Example 1 ********************************************////
    protected ex1Output: IConfirmationDialogResult | null = null;

    protected async ex1ButtonClick(): Promise<void> {
        const result = await confirmation.showDeactivate('cm:carePlanGoal.$');
        this.ex1Output = result;
    }

    ////****************** Example 2 ********************************************////
    protected ex2Text: string = 'Custom Text';
    protected ex2SubText: string = 'Custom Sub Text';
    protected ex2Output: IConfirmationDialogResult | null = null;

    protected async ex2ButtonYesNoClick(): Promise<void> {
        const result = await confirmation.showCustom(this.ex2Text, this.ex2SubText, confirmation.options.YesNo);
        this.ex2Output = result;
    }

    protected async ex2ButtonOkClick(): Promise<void> {
        const result = await confirmation.showCustom(this.ex2Text, this.ex2SubText, confirmation.options.OK);
        this.ex2Output = result;
    }

    protected async ex2ButtonOkCancelClick(): Promise<void> {
        const result = await confirmation.showCustom(this.ex2Text, this.ex2SubText, confirmation.options.OKCancel);
        this.ex2Output = result;
    }

    protected async ex2ButtonReasonClick(): Promise<void> {
        const result = await confirmation.showCustom(this.ex2Text, this.ex2SubText, confirmation.options.OKCancel, true);
        this.ex2Output = result;
    }

}
